












































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { FarmProperties } from './types';

@Component({
  name: "FarmDrawConfirm",
})
export default class FarmDrawConfirm extends Vue {
  @Prop({ type: Boolean, default: false })
  private isVisible!: boolean;

  @Prop({ type: Object, required: true })
  private farm!: FarmProperties;

  private farmName: string = this.farm.farmName;

  private mounted() {
    this.farmName = this.farm.farmName;
  }


  @Emit('onsubmit')
  public confirmCreateFarm() {
    const name = this.farmName;
    this.farmName = '';
    return name;
  }

  @Emit('oncancel')
  public editFarm() {
    this.farmName = '';
  }
}
